import { styled } from 'style'

const RootStyled = styled('div', {
  maxWidth: '91vw',
  width: '$full',
  overflow: 'hidden',
  overflowX: 'auto',
  clear: 'both',

  '@md': {
    maxWidth: '$full',
  },
})

const TableStyled = styled('table', {
  width: '$full',
})

const TableHeadStyled = styled('thead', {
  variants: {
    borderBottom: {
      true: {
        borderBottom: '1px solid $bg3',
      },
    },
  },

  defaultVariants: {
    borderBottom: true,
  },
})

const TableRowStyled = styled('tr', {})

const ThStyled = styled('th', {
  fontSize: '$sm',
  lineHeight: '$sm',
  fontWeight: '$medium',
  color: '$text3',
  pb: '$2',
  px: '$3',

  variants: {
    styled: {
      true: {
        fontSize: '$sm',
        lineHeight: '$sm',
        fontWeight: '$medium',
        color: '$text3',
        pb: '$2',
        px: '$3',
      },
    },
  },

  defaultVariants: {
    styled: true,
  },
})

const TableBodyStyled = styled('tbody', {
  variants: {
    borderBottom: {
      true: {
        'tr:not(:last-child)': {
          borderBottom: '1px solid $bg3',
        },
      },
    },
  },
})

const TdStyled = styled('td', {
  variants: {
    styled: {
      true: {
        fontSize: '$sm',
        lineHeight: '$sm',
        fontWeight: '$medium',
        color: '$text1',
        py: '$4',
        px: '$3',
      },
    },
    noWrap: {
      true: {
        whiteSpace: 'nowrap',
      },
    },
  },

  defaultVariants: {
    styled: true,
  },
})

export const Root = RootStyled
export const Table = TableStyled
export const Head = TableHeadStyled
export const Body = TableBodyStyled
export const Row = TableRowStyled
export const CellHeader = ThStyled
export const Cell = TdStyled
